// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-background {
    width: 100%;
    flex-shrink: 0;
    border-radius: 1.5rem;
    background-color: var(--background-color);
    margin: 0rem 0.75rem;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    overflow-x: auto;
}

.custom-table {
    //height: 100vh;
    width: 100%;
    border-collapse: collapse;
}

.custom-table th,
.custom-table td {
    height: 4.3125rem;
    padding: 1rem 0 1rem 1rem;
}

.custom-table th:first-child,
.custom-table td:first-child {
    border-radius: 0.75rem 0 0 0.75rem;
}

.custom-table th:last-child,
.custom-table td:last-child {
    border-radius: 0 0.75rem 0.75rem 0;
}

.custom-table td {
    position: relative;
}

.custom-table td:last-child::after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    background-color: var(--background-color);
    bottom: 0;
    left: 0;
    transition: width 0.3s ease;
}

.custom-table td:last-child:hover::after {
    width: 100%;
}

.custom-table .align-left {
    text-align: left;
}

.custom-table .align-right {
    text-align: right;
}

.custom-table tr:nth-child(even) {
    background: rgba(217, 217, 217, 0.15);
}

.custom-table tr.with-link:hover {
    background-color: rgba(217, 217, 217, 0.3);
    cursor: pointer;
}

.custom-table tr.with-link:hover td:last-child::after {
    width: 100%;
}

.custom-table .table-header:hover {
    background-color: #FFF;
    cursor: default;
}


.custom-table td.with-link:hover::after {
    width: 100%;
}

.pagination-card {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0.75rem;
    border-radius: 5rem;
    background-color: var(--background-color);
    padding: 1rem 2rem;
}

@media (max-width: 1024px) {
    .pagination-card {
        border-radius: 1.5rem;
        padding: 1rem 1.25rem;
        justify-content: center;
    }
}

.pagination-info {
    flex-grow: 1;
}

.pagination-controls {
    display: flex;
    align-items: center;
}

.pagination-controls button {
    margin: 0 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 0.5rem;
    background-color: var(--primary-color);
    color: #1E1E1E;
    cursor: pointer;
}

.page-numbers {
    display: flex;
}

.page-numbers span {
    margin: 0 0.25rem;
    padding: 0.5rem;
    border: 1px solid var(--primary-color);
    border-radius: 0.5rem;
    cursor: pointer;
}

.page-numbers span.current-page {
    background-color: #5148FA;
    color: white;
}

input {
    width: 100%;
    padding: 8px;
    border: 1px solid #C5C5C5;
    border-radius: 5px;
    background-color: #fff;
    color: #000;
    /* Text color */
}

.adviser-button {
    width: 12rem;
    height: 2.75rem;
    border-radius: 1rem;
}

.adviser-button.toggle-enabled {
    background: #14B8A6;
}

.adviser-button p {
    font-size: 0.8rem;
}

.tooltip-container {
    position: relative;
    display: inline-block;
    cursor: help;
}

.tooltip-container .tooltip-text {
    visibility: hidden;
    width: 250px;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 10px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -125px;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 12px;
    line-height: 1.4;
}

.tooltip-container .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
}

.tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}

/* ── Filter search bar ────────────────────────────────────── */

.filter-search-wrapper {
  position: relative;
  margin-bottom: 1rem;
}

.filter-search-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem;
  min-height: 2.5rem;
  padding: 0.375rem 0.625rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  background: #fff;
  cursor: text;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.filter-search-bar.focused,
.filter-search-bar:focus-within {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.filter-search-icon {
  color: #9ca3af;
  flex-shrink: 0;
  margin-right: 0.125rem;
}

.filter-search-input {
  flex: 1;
  min-width: 140px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.875rem;
  color: var(--text-color);
  padding: 0;
}

.filter-search-input::-moz-placeholder {
  color: #9ca3af;
}

.filter-search-input::placeholder {
  color: #9ca3af;
}

/* ── Chips ────────────────────────────────────────────────── */

.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  padding: 0.125rem 0.5rem;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 9999px;
  font-size: 0.8125rem;
  white-space: nowrap;
}

.filter-chip--pending {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.filter-chip-column {
  font-weight: 600;
  color: #4f46e5;
}

.filter-chip--pending .filter-chip-column {
  color: #16a34a;
}

.filter-chip-separator {
  color: #818cf8;
  font-weight: 500;
}

.filter-chip-value {
  color: #3730a3;
}

.filter-chip-remove {
  margin-left: 0.25rem;
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  color: #818cf8;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  border-radius: 9999px;
  padding: 0;
  transition: background 0.1s;
}

.filter-chip-remove:hover {
  background: #c7d2fe;
  color: #3730a3;
}

.filter-clear-btn {
  margin-left: auto;
  border: none;
  background: none;
  color: #9ca3af;
  font-size: 1.125rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 0.125rem;
  transition: color 0.1s;
  flex-shrink: 0;
}

.filter-clear-btn:hover {
  color: #374151;
}

/* ── Dropdown ─────────────────────────────────────────────── */

.filter-dropdown {
  position: absolute;
  top: calc(100% + 0.375rem);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 50;
  overflow: hidden;
  padding: 0.375rem 0;
}

.filter-dropdown-label {
  padding: 0.375rem 0.75rem 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
}

.filter-dropdown-item {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  text-align: left;
  border: none;
  background: none;
  font-size: 0.875rem;
  color: var(--text-color);
  cursor: pointer;
  transition: background 0.1s;
}

.filter-dropdown-item:hover {
  background: #f5f3ff;
  color: #4f46e5;
}

.filter-dropdown-divider {
  height: 1px;
  background: #f3f4f6;
  margin: 0.375rem 0;
}

.filter-dropdown-hint {
  padding: 0.25rem 0.75rem 0.375rem;
  font-size: 0.75rem;
  color: #9ca3af;
  margin: 0;
}

.filter-dropdown-hint kbd {
  display: inline-block;
  padding: 0.0625rem 0.3125rem;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
  font-size: 0.6875rem;
  font-family: inherit;
  color: #374151;
}

.filter-radio-group {
  display: flex;
  gap: 0.375rem;
  align-items: center;
  flex-wrap: wrap;
}

.filter-radio-option {
  padding: 0.125rem 0.625rem;
  border: 1px solid #c7d2fe;
  border-radius: 9999px;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.1s, border-color 0.1s;
}

.filter-radio-option:hover {
  background: #e0e7ff;
  border-color: #a5b4fc;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/table/table.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB,yCAAyC;IACzC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,yCAAyC;IACzC,SAAS;IACT,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI;QACI,qBAAqB;QACrB,qBAAqB;QACrB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,qBAAqB;IACrB,sCAAsC;IACtC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,gEAAgE;;AAEhE;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAFA;EACE,cAAc;AAChB;;AAEA,gEAAgE;;AAEhE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;;AAEhE;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".card-background {\n    width: 100%;\n    flex-shrink: 0;\n    border-radius: 1.5rem;\n    background-color: var(--background-color);\n    margin: 0rem 0.75rem;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    overflow-x: auto;\n}\n\n.custom-table {\n    //height: 100vh;\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.custom-table th,\n.custom-table td {\n    height: 4.3125rem;\n    padding: 1rem 0 1rem 1rem;\n}\n\n.custom-table th:first-child,\n.custom-table td:first-child {\n    border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.custom-table th:last-child,\n.custom-table td:last-child {\n    border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.custom-table td {\n    position: relative;\n}\n\n.custom-table td:last-child::after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 2px;\n    background-color: var(--background-color);\n    bottom: 0;\n    left: 0;\n    transition: width 0.3s ease;\n}\n\n.custom-table td:last-child:hover::after {\n    width: 100%;\n}\n\n.custom-table .align-left {\n    text-align: left;\n}\n\n.custom-table .align-right {\n    text-align: right;\n}\n\n.custom-table tr:nth-child(even) {\n    background: rgba(217, 217, 217, 0.15);\n}\n\n.custom-table tr.with-link:hover {\n    background-color: rgba(217, 217, 217, 0.3);\n    cursor: pointer;\n}\n\n.custom-table tr.with-link:hover td:last-child::after {\n    width: 100%;\n}\n\n.custom-table .table-header:hover {\n    background-color: #FFF;\n    cursor: default;\n}\n\n\n.custom-table td.with-link:hover::after {\n    width: 100%;\n}\n\n.pagination-card {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    margin: 1rem 0.75rem;\n    border-radius: 5rem;\n    background-color: var(--background-color);\n    padding: 1rem 2rem;\n}\n\n@media (max-width: 1024px) {\n    .pagination-card {\n        border-radius: 1.5rem;\n        padding: 1rem 1.25rem;\n        justify-content: center;\n    }\n}\n\n.pagination-info {\n    flex-grow: 1;\n}\n\n.pagination-controls {\n    display: flex;\n    align-items: center;\n}\n\n.pagination-controls button {\n    margin: 0 0.5rem;\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: 0.5rem;\n    background-color: var(--primary-color);\n    color: #1E1E1E;\n    cursor: pointer;\n}\n\n.page-numbers {\n    display: flex;\n}\n\n.page-numbers span {\n    margin: 0 0.25rem;\n    padding: 0.5rem;\n    border: 1px solid var(--primary-color);\n    border-radius: 0.5rem;\n    cursor: pointer;\n}\n\n.page-numbers span.current-page {\n    background-color: #5148FA;\n    color: white;\n}\n\ninput {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #C5C5C5;\n    border-radius: 5px;\n    background-color: #fff;\n    color: #000;\n    /* Text color */\n}\n\n.adviser-button {\n    width: 12rem;\n    height: 2.75rem;\n    border-radius: 1rem;\n}\n\n.adviser-button.toggle-enabled {\n    background: #14B8A6;\n}\n\n.adviser-button p {\n    font-size: 0.8rem;\n}\n\n.tooltip-container {\n    position: relative;\n    display: inline-block;\n    cursor: help;\n}\n\n.tooltip-container .tooltip-text {\n    visibility: hidden;\n    width: 250px;\n    background-color: #333;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 10px;\n    position: absolute;\n    z-index: 1;\n    bottom: 125%;\n    left: 50%;\n    margin-left: -125px;\n    opacity: 0;\n    transition: opacity 0.3s;\n    font-size: 12px;\n    line-height: 1.4;\n}\n\n.tooltip-container .tooltip-text::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: #333 transparent transparent transparent;\n}\n\n.tooltip-container:hover .tooltip-text {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* ── Filter search bar ────────────────────────────────────── */\n\n.filter-search-wrapper {\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.filter-search-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.375rem;\n  min-height: 2.5rem;\n  padding: 0.375rem 0.625rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  background: #fff;\n  cursor: text;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.filter-search-bar.focused,\n.filter-search-bar:focus-within {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.filter-search-icon {\n  color: #9ca3af;\n  flex-shrink: 0;\n  margin-right: 0.125rem;\n}\n\n.filter-search-input {\n  flex: 1;\n  min-width: 140px;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 0.875rem;\n  color: var(--text-color);\n  padding: 0;\n}\n\n.filter-search-input::placeholder {\n  color: #9ca3af;\n}\n\n/* ── Chips ────────────────────────────────────────────────── */\n\n.filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.125rem;\n  padding: 0.125rem 0.5rem;\n  background: #eef2ff;\n  border: 1px solid #c7d2fe;\n  border-radius: 9999px;\n  font-size: 0.8125rem;\n  white-space: nowrap;\n}\n\n.filter-chip--pending {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.filter-chip-column {\n  font-weight: 600;\n  color: #4f46e5;\n}\n\n.filter-chip--pending .filter-chip-column {\n  color: #16a34a;\n}\n\n.filter-chip-separator {\n  color: #818cf8;\n  font-weight: 500;\n}\n\n.filter-chip-value {\n  color: #3730a3;\n}\n\n.filter-chip-remove {\n  margin-left: 0.25rem;\n  width: 1rem;\n  height: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  color: #818cf8;\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 9999px;\n  padding: 0;\n  transition: background 0.1s;\n}\n\n.filter-chip-remove:hover {\n  background: #c7d2fe;\n  color: #3730a3;\n}\n\n.filter-clear-btn {\n  margin-left: auto;\n  border: none;\n  background: none;\n  color: #9ca3af;\n  font-size: 1.125rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 0.125rem;\n  transition: color 0.1s;\n  flex-shrink: 0;\n}\n\n.filter-clear-btn:hover {\n  color: #374151;\n}\n\n/* ── Dropdown ─────────────────────────────────────────────── */\n\n.filter-dropdown {\n  position: absolute;\n  top: calc(100% + 0.375rem);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  z-index: 50;\n  overflow: hidden;\n  padding: 0.375rem 0;\n}\n\n.filter-dropdown-label {\n  padding: 0.375rem 0.75rem 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0;\n}\n\n.filter-dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  border: none;\n  background: none;\n  font-size: 0.875rem;\n  color: var(--text-color);\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\n.filter-dropdown-item:hover {\n  background: #f5f3ff;\n  color: #4f46e5;\n}\n\n.filter-dropdown-divider {\n  height: 1px;\n  background: #f3f4f6;\n  margin: 0.375rem 0;\n}\n\n.filter-dropdown-hint {\n  padding: 0.25rem 0.75rem 0.375rem;\n  font-size: 0.75rem;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.filter-dropdown-hint kbd {\n  display: inline-block;\n  padding: 0.0625rem 0.3125rem;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.25rem;\n  font-size: 0.6875rem;\n  font-family: inherit;\n  color: #374151;\n}\n\n.filter-radio-group {\n  display: flex;\n  gap: 0.375rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.filter-radio-option {\n  padding: 0.125rem 0.625rem;\n  border: 1px solid #c7d2fe;\n  border-radius: 9999px;\n  background: #eef2ff;\n  color: #4f46e5;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.1s, border-color 0.1s;\n}\n\n.filter-radio-option:hover {\n  background: #e0e7ff;\n  border-color: #a5b4fc;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
